var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCycle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_444_891",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 0H0V96H96V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_444_891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9999 57C84.9299 57 92.9999 65.07 92.9999 75C92.9999 84.93 84.9299 93 74.9999 93C65.0699 93 56.9999 84.93 56.9999 75C56.9999 65.07 65.0699 57 74.9999 57ZM31.0796 60C35.8496 63.24 38.9996 68.79 38.9996 75C38.9996 84.93 30.9296 93 20.9996 93C11.0696 93 2.99957 84.93 2.99957 75C2.99957 72.87 2.99957 66 8.99958 60H31.0796Z",
    fill: "#FFC44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0005 75V57C48.0005 57 30.0005 48 33.0005 42C39.0005 30 48.0005 24 54.0005 21C60.0005 36 75.0005 42 75.0005 42M24.0005 48H6.00048M21.0005 36H3.00048M4.03758 68.9679C3.36558 70.8549 2.99957 72.8859 2.99957 75.0009C2.99957 84.9399 11.0606 93.0009 20.9996 93.0009C30.9416 93.0009 38.9996 84.9399 38.9996 75.0009C38.9996 68.7849 35.8526 63.2349 31.0676 60.0009H8.99958M39.0005 51.4746C39.0005 51.4746 44.0615 39.0006 59.0615 30.0006M93.0005 75C93.0005 65.061 84.9395 57 75.0005 57C65.0615 57 57.0005 65.061 57.0005 75C57.0005 84.939 65.0615 93 75.0005 93C84.9395 93 93.0005 84.939 93.0005 75ZM69.0005 9C69.0005 5.688 66.3125 3 63.0005 3C59.6885 3 57.0005 5.688 57.0005 9C57.0005 12.312 59.6885 15 63.0005 15C66.3125 15 69.0005 12.312 69.0005 9Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycle);
export default __webpack_public_path__ + "static/media/cycle.221fa5938f2a7a2edd47b4c3193585e9.svg";
export { ForwardRef as ReactComponent };